import React, {ReactElement} from "react";
import {Navigate, Route} from "react-router-dom";
import TaleChasersHomePage from "../../pages/chase/story/comic/talechasers/TaleChasersHomePage";
import ComicLatestRedirectPage from "../../pages/chase/story/comic/latest/ComicLatestRedirectPage";
import ComicDisplayPage from "../../pages/chase/story/comic/display/ComicDisplayPage";
import AdvanceComicDisplayPage from "../../pages/chase/story/comic/advance/AdvanceComicDisplayPage";
import CharactersPage from "../../pages/chase/story/character/CharactersPage";
import CharacterDisplayPage from "../../pages/chase/story/character/display/CharacterDisplayPage";
import ChaseMagicPage from "../../pages/chase/story/chasemagic/ChaseMagicPage";
import WorldRouter from "./world/WorldRouter";

class StoryRouter {

    public static getRoutes(): ReactElement {
        return (
            <>
                <Route path="comics">
                    <Route index element={<Navigate replace to="talechasers"/>}/>
                    <Route path=":comic">
                        <Route index element={<TaleChasersHomePage/>}/>
                        <Route path="latest" element={<ComicLatestRedirectPage/>}/>
                        <Route path=":chapter">
                            <Route index element={<Navigate replace to="1"/>}/>
                            <Route path=":page">
                                <Route index element={<ComicDisplayPage/>}/>
                                <Route path=":id" element={<AdvanceComicDisplayPage/>}/>
                            </Route>
                        </Route>
                    </Route>
                </Route>
                <Route path="characters">
                    <Route index element={<CharactersPage/>}/>
                    <Route path=":name" element={<CharacterDisplayPage/>}/>
                </Route>
                {WorldRouter.getRoutes()}
                <Route path="chasemagic">
                    <Route index element={<ChaseMagicPage/>}/>
                </Route>
            </>
        );
    }
}

export default StoryRouter;